import { useStyles } from "@b2bportal/core-themes";
import { type ChatComponents, CHAT_NAME } from "../types/components";

export const useChatStyles = (
  componentName: keyof typeof ChatComponents,
  defaultStyles?: object
) => {
  return useStyles(CHAT_NAME, componentName, defaultStyles);
};
